// Fuente compartida: tools/sincronizar-cupones.cjs distribuye este archivo y CuponContenido.vue.
export const visibilidadPredeterminada = {
    mostrar_uso: 1,
    mostrar_descuento: 1,
    mostrar_observacion_descuento: 1,
    mostrar_instrucciones: 1,
    mostrar_sobre_la_marca: 1,
    mostrar_terminos_y_condiciones: 1,
    mostrar_coordenadas: 1,
    mostrar_texto_personalizado: 0,
    mostrar_boton_personalizado: 0,
    mostrar_texto_personalizado_2: 0,
    mostrar_boton_personalizado_2: 0,
};

export function esVisible(cupon, campo) {
    const key = `mostrar_${campo}`;
    return Number(cupon[key] ?? visibilidadPredeterminada[key]) === 1;
}

export function normalizarPresentacion(cupon = {}) {
    const result = {
        texto_personalizado: '', boton_personalizado_titulo: '', boton_personalizado_url: '',
        texto_personalizado_2: '', boton_personalizado_titulo_2: '', boton_personalizado_url_2: '',
        ...cupon,
    };
    Object.keys(visibilidadPredeterminada).forEach(key => {
        result[key] = Number(cupon[key] ?? visibilidadPredeterminada[key]) === 1 ? 1 : 0;
    });
    return result;
}

export function enlaceWebSeguro(value) {
    const text = String(value || '').trim();
    if (!/^https?:\/\//i.test(text)) return '';
    try {
        const url = new URL(text);
        return url.hostname ? url.href : '';
    } catch {
        return '';
    }
}
